import { Injectable } from '@angular/core';
import { FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

const SOLO_NUMEROS_REGEX = /^\d+$/;

/**
 * Validator Service
 *
 * Servicio para realizar validaciones de datos
 *
 * Modo de instanciacion:
 *
 * @component({})
 * export class componente {
 *  constructor (private _validatorService: ValidatorService) {
 *
 *  }
 * }
 */
@Injectable()
export class ValidatorService {


  constructor() {
  }

  /**
   * Solo Numeros Form Validartor
   *
   * Funcion que se utiliza en la validacion de forlmularios reactivos, para validar que el valor solo tenga numeros.
   *
   * Modo de uso:
   * telefono: new FormControl('', [this._validatorService.soloNumerosFormValidator]);
   *
   * @param {FormControl} control
   * @returns {{notNumeric: boolean}}
   */
  public soloNumerosFormValidator = (control: FormControl): { [key: string]: any } | null => {
    return this.soloNumeros(control.value) ? null : {noEsNumerico: true};
  };

  /**
   * Solo Numeros
   * Funcion para validar si un string contiene solo valores numericos sin signo ni decimales
   *
   * @param {string} valor
   * @returns {boolean}
   */
  public soloNumeros = (valor: any): boolean => {
    return (!this.isEmpty(valor) && SOLO_NUMEROS_REGEX.test(valor));
  };

  /**
   * Is Empty
   * Valida si una variable esta vacia
   * @param data
   * @returns {boolean}
   */
  public isEmpty = (data: any): boolean => {
    if (typeof(data) === 'object') {
      if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
        return true;
      } else if (!data) {
        return true;
      }
      return false;
    } else if (typeof(data) === 'string') {
      if (!data.trim()) {
        return true;
      }
      return false;
    } else if (typeof(data) === 'undefined') {
      return true;
    } else {
      return false;
    }
  };

  public nombreApellidoFormValidator = (control: FormControl): { [key: string]: any } | null => {
    const pattern = /^[a-zA-Z\s]*$/; // Expresión regular para permitir solo letras y espacios
    return pattern.test(control.value) ? null : { noEsValido: true };
  };

  public correoFormValidator = (control: FormControl): { [key: string]: any } | null => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular para validar formato de correo
    return pattern.test(control.value) ? null : { noEsValido: true };
  };
  
  public ccValidation = (control: FormControl): { [key: string]: any } | null => {
    const value = control.value;

    if (value.length >= 6 && value.length <= 8) {
      if (value < 800000 || value > 99999999) {
        return { rangeInvalid: true };
      }
    } else if (value.length === 10) {
      if (value <= 1000000000) {
        return { minValueInvalid: true };
      }
    }

    return null;
  };

  public cePasaporteValidation = (control: FormControl): { [key: string]: any } | null => {
    const pattern = /^[a-zA-Z0-9]+$/;
    return pattern.test(control.value) ? null : { noEsValido: true };
  };

  public nitValidation = (control: FormControl): { [key: string]: any } | null => {
    const pattern = /^[0-9]+$/;
    return pattern.test(control.value) && control.value.length === 9 ? null : { noEsValido: true };
  };

  public symbolValidation = (control: FormControl): { [key: string]: any } | null => {
    const pattern = /^[a-zA-Z0-9]+$/;
    if (!pattern.test(control.value)) {
      return { noEsValido: true };
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/app/control-core/services/validator-service.ts